export const AUTH_START = "AUTH_START";
export const AUTH_OTP = "AUTH_OTP";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const FETCH_TOP_EARNERS_INIT = "FETCH_TOP_EARNERS_INIT";
export const FETCH_TOP_EARNERS_SUCCESS = "FETCH_TOP_EARNERS_SUCCESS";
export const FETCH_TOP_EARNERS_FAIL = "FETCH_TOP_EARNERS_FAIL";
export const RESET_TOP_EARNERS = "RESET_TOP_EARNERS";

export const FETCH_PLAYER_DATA_INIT = "FETCH_PLAYER_DATA_INIT";
export const FETCH_PLAYER_DATA_SUCCESS = "FETCH_PLAYER_DATA_SUCCESS";
export const FETCH_PLAYER_DATA_FAIL = "FETCH_PLAYER_DATA_FAIL";
export const RESET_PLAYER_DATA = "RESET_PLAYER_DATA";

export const FETCH_TRANSACTION_HISTORY_INIT = "FETCH_TRANSACTION_HISTORY_INIT";
export const FETCH_TRANSACTION_HISTORY_SUCCESS =
  "FETCH_TRANSACTION_HISTORY_SUCCESS";
export const FETCH_TRANSACTION_HISTORY_FAIL = "FETCH_TRANSACTION_HISTORY_FAIL";

export const SET_TRANSACTION_HISTORY_INIT = "SET_TRANSACTION_HISTORY_INIT";
export const SET_TRANSACTION_HISTORY_SUCCESS =
  "SET_TRANSACTION_HISTORY_SUCCESS";
export const SET_TRANSACTION_HISTORY_FAIL = "SET_TRANSACTION_HISTORY_FAIL";

export const FETCH_DEPOSIT_HISTORY_INIT = "FETCH_DEPOSIT_HISTORY_INIT";
export const FETCH_DEPOSIT_HISTORY_SUCCESS = "FETCH_DEPOSIT_HISTORY_SUCCESS";
export const FETCH_DEPOSIT_HISTORY_FAIL = "FETCH_DEPOSIT_HISTORY_FAIL";

export const SET_DEPOSIT_HISTORY_INIT = "SET_DEPOSIT_HISTORY_INIT";
export const SET_DEPOSIT_HISTORY_SUCCESS = "SET_DEPOSIT_HISTORY_SUCCESS";
export const SET_DEPOSIT_HISTORY_FAIL = "SET_DEPOSIT_HISTORY_FAIL";

export const FETCH_REFUND_HISTORY_INIT = "FETCH_REFUND_HISTORY_INIT";
export const FETCH_REFUND_HISTORY_SUCCESS = "FETCH_REFUND_HISTORY_SUCCESS";
export const FETCH_REFUND_HISTORY_FAIL = "FETCH_REFUND_HISTORY_FAIL";

export const SET_VOUCHER_HISTORY_INIT = "SET_VOUCHER_HISTORY_INIT";
export const SET_VOUCHER_HISTORY_SUCCESS = "SET_VOUCHER_HISTORY_SUCCESS";
export const SET_VOUCHER_HISTORY_FAIL = "SET_VOUCHER_HISTORY_FAIL";

export const FETCH_WITHDRAWAL_HISTORY_INIT = "FETCH_WITHDRAWAL_HISTORY_INIT";
export const FETCH_WITHDRAWAL_HISTORY_SUCCESS =
  "FETCH_WITHDRAWAL_HISTORY_SUCCESS";
export const FETCH_WITHDRAWAL_HISTORY_FAIL = "FETCH_WITHDRAWAL_HISTORY_FAIL";

export const SET_WITHDRAWAL_HISTORY_INIT = "SET_WITHDRAWAL_HISTORY_INIT";
export const SET_WITHDRAWAL_HISTORY_SUCCESS = "SET_WITHDRAWAL_HISTORY_SUCCESS";
export const SET_WITHDRAWAL_HISTORY_FAIL = "SET_WITHDRAWAL_HISTORY_FAIL";

export const SET_WITHDRAWAL_STATUS = "SET_WITHDRAWAL_STATUS";

export const FETCH_CREDIT_TRANSFER_INIT = "FETCH_CREDIT_TRANSFER_INIT";
export const FETCH_CREDIT_TRANSFER_SUCCESS = "FETCH_CREDIT_TRANSFER_SUCCESS";
export const FETCH_CREDIT_TRANSFER_FAIL = "FETCH_CREDIT_TRANSFER_FAIL";

export const SET_CREDIT_TRANSFER_INIT = "SET_CREDIT_TRANSFER_INIT";
export const SET_CREDIT_TRANSFER_SUCCESS = "SET_CREDIT_TRANSFER_SUCCESS";
export const SET_CREDIT_TRANSFER_FAIL = "SET_CREDIT_TRANSFER_FAIL";

export const FETCH_CREDIT_CARD_INIT = "FETCH_CREDIT_CARD_INIT";
export const FETCH_CREDIT_CARD_SUCCESS = "FETCH_CREDIT_CARD_SUCCESS";
export const FETCH_CREDIT_CARD_FAIL = "FETCH_CREDIT_CARD_FAIL";

export const SET_CREDIT_CARD_CVV = "SET_CREDIT_CARD_CVV";

export const SET_CREDIT_CARD_INIT = "SET_CREDIT_CARD_INIT";
export const SET_CREDIT_CARD_SUCCESS = "SET_CREDIT_CARD_SUCCESS";
export const SET_CREDIT_CARD_FAIL = "SET_CREDIT_CARD_FAIL";

export const REMOVE_CREDIT_CARD_INIT = "REMOVE_CREDIT_CARD_INIT";
export const REMOVE_CREDIT_CARD_FAIL = "REMOVE_CREDIT_CARD_FAIL";
export const REMOVE_CREDIT_CARD_SUCCESS = "REMOVE_CREDIT_CARD_SUCCESS";

export const FETCH_RAVE_CARD_INIT = "FETCH_RAVE_CARD_INIT";
export const FETCH_RAVE_CARD_SUCCESS = "FETCH_RAVE_CARD_SUCCESS";
export const FETCH_RAVE_CARD_FAIL = "FETCH_RAVE_CARD_FAIL";

export const REMOVE_RAVE_CARD_INIT = "REMOVE_RAVE_CARD_INIT";
export const REMOVE_RAVE_CARD_FAIL = "REMOVE_RAVE_CARD_FAIL";
export const REMOVE_RAVE_CARD_SUCCESS = "REMOVE_RAVE_CARD_SUCCESS";

export const FETCH_BANK_ACCOUNT_INIT = "FETCH_BANK_ACCOUNT_INIT";
export const FETCH_BANK_ACCOUNT_SUCCESS = "FETCH_BANK_ACCOUNT_SUCCESS";
export const FETCH_BANK_ACCOUNT_FAIL = "FETCH_BANK_ACCOUNT_FAIL";

export const SET_BANK_ACCOUNT_INIT = "SET_BANK_ACCOUNT_INIT";
export const SET_BANK_ACCOUNT_SUCCESS = "SET_BANK_ACCOUNT_SUCCESS";
export const SET_BANK_ACCOUNT_FAIL = "SET_BANK_ACCOUNT_FAIL";

export const REMOVE_BANK_ACCOUNT_INIT = "REMOVE_BANK_ACCOUNT_INIT";
export const REMOVE_BANK_ACCOUNT_FAIL = "REMOVE_BANK_ACCOUNT_FAIL";
export const REMOVE_BANK_ACCOUNT_SUCCESS = "REMOVE_BANK_ACCOUNT_SUCCESS";

export const FETCH_WITHDRAWAL_BANK_ACCOUNT_INIT =
  "FETCH_WITHDRAWAL_BANK_ACCOUNT_INIT";
export const FETCH_WITHDRAWAL_BANK_ACCOUNT_SUCCESS =
  "FETCH_WITHDRAWAL_BANK_ACCOUNT_SUCCESS";
export const FETCH_WITHDRAWAL_BANK_ACCOUNT_FAIL =
  "FETCH_WITHDRAWAL_BANK_ACCOUNT_FAIL";

export const SET_WITHDRAWAL_BANK_ACCOUNT_INIT =
  "SET_WITHDRAWAL_BANK_ACCOUNT_INIT";
export const SET_WITHDRAWAL_BANK_ACCOUNT_SUCCESS =
  "SET_WITHDRAWAL_BANK_ACCOUNT_SUCCESS";
export const SET_WITHDRAWAL_BANK_ACCOUNT_FAIL =
  "SET_WITHDRAWAL_BANK_ACCOUNT_FAIL";

export const REMOVE_WITHDRAWAL_BANK_ACCOUNT_INIT =
  "REMOVE_WITHDRAWAL_BANK_ACCOUNT_INIT";
export const REMOVE_WITHDRAWAL_BANK_ACCOUNT_FAIL =
  "REMOVE_WITHDRAWAL_BANK_ACCOUNT_FAIL";
export const REMOVE_WITHDRAWAL_BANK_ACCOUNT_SUCCESS =
  "REMOVE_WITHDRAWAL_BANK_ACCOUNT_SUCCESS";

export const SET_CHARGE_REFERENCE = "SET_CHARGE_REFERENCE";

export const SET_VOUCHER_VALUE = "SET_VOUCHER_VALUE";

export const SET_COIN_BALANCE_INIT = "SET_COIN_BALANCE_INIT";
export const SET_COIN_BALANCE_SUCCESS = "SET_COIN_BALANCE_SUCCESS";
export const SET_COIN_BALANCE_FAIL = "SET_COIN_BALANCE_FAIL";

export const SET_CASH_BALANCE_INIT = "SET_CASH_BALANCE_INIT";
export const SET_CASH_BALANCE_SUCCESS = "SET_CASH_BALANCE_SUCCESS";
export const SET_CASH_BALANCE_FAIL = "SET_CASH_BALANCE_FAIL";

export const OPEN_SUBMIT_PIN_MODAL = "OPEN_SUBMIT_PIN_MODAL";
export const CLOSE_SUBMIT_PIN_MODAL = "CLOSE_SUBMIT_PIN_MODAL";

export const OPEN_SUBMIT_OTP_MODAL = "OPEN_SUBMIT_OTP_MODAL";
export const CLOSE_SUBMIT_OTP_MODAL = "CLOSE_SUBMIT_OTP_MODAL";

export const OPEN_SUBMIT_PHONE_MODAL = "OPEN_SUBMIT_PHONE_MODAL";
export const CLOSE_SUBMIT_PHONE_MODAL = "CLOSE_SUBMIT_PHONE_MODAL";

export const OPEN_SUBMIT_BIRTHDAY_MODAL = "OPEN_SUBMIT_BIRTHDAY_MODAL";
export const CLOSE_SUBMIT_BIRTHDAY_MODAL = "CLOSE_SUBMIT_BIRTHDAY_MODAL";

export const OPEN_TRANSACTION_SUCCESS_MODAL = "OPEN_TRANSACTION_SUCCESS_MODAL";
export const CLOSE_TRANSACTION_SUCCESS_MODAL =
  "CLOSE_TRANSACTION_SUCCESS_MODAL";

export const OPEN_TRANSACTION_FAIL_MODAL = "OPEN_TRANSACTION_FAIL_MODAL";
export const CLOSE_TRANSACTION_FAIL_MODAL = "CLOSE_TRANSACTION_FAIL_MODAL";
